import { DeleteIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Visibility } from "../clients/BackOfficeApi";
import { FormattedMessage } from "react-intl";
import { Flex } from "@chakra-ui/react";

export function VisibilityIcon({ visibility }: { visibility: Visibility }) {
  return (
    <Flex align="center">
      {visibility === Visibility.ARCHIVED && <DeleteIcon mr={2} />}
      {visibility === Visibility.PUBLISHED && <ViewIcon mr={2} />}
      {visibility === Visibility.UNPUBLISHED && <ViewOffIcon mr={2} />}
      <FormattedMessage defaultMessage={visibility} id={`visibility.${visibility}`} />
    </Flex>
  );
}
